import {parseUrlProps} from '@map/urlProps';
import {useMemo} from 'react';

export function useUrlProps() {
    const {search} = location;
    return useMemo(() => parseUrlProps(search), [search]);
}
